import { render, staticRenderFns } from "./IgPaymentClientInfo.vue?vue&type=template&id=17161bab&"
import script from "./IgPaymentClientInfo.vue?vue&type=script&lang=js&"
export * from "./IgPaymentClientInfo.vue?vue&type=script&lang=js&"
import style0 from "./IgPaymentClientInfo.vue?vue&type=style&index=0&id=17161bab&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports